import React from 'react';

/** -------------------------------------------------------------------------- **/
function AssetInfo({assetInfo}) {

    return (
        <>
            <div className="sub_title">
                    {'■ 시스템 현황'}
            </div>
            <div style={{padding: '0px 10px 10px 10px'}}>
                <div className="section" style={{minWidth:'500px'}}>
                    <table className='search'>
                        <colgroup>
                            <col style={{width:'20%'}} />
                            <col style={{width:'30%'}} />
                            <col style={{width:'20%'}} />
                            <col style={{width:'30%'}} />
                        </colgroup>
                        <tbody>
                        <tr>
                            <th>Index</th>
                            <td>{assetInfo?.asset_cd}</td>
                            <th>자산명</th>
                            <td>{assetInfo?.asset_nm}</td>
                        </tr>
                        <tr>
                            <th>자산유형</th>
                            <td>{assetInfo?.asset_spec}</td>
                            <th>IP Address</th>
                            <td>{assetInfo?.asset_ip}</td>
                        </tr>
                        <tr>
                            <th>OS 및 버전</th>
                            <td>{assetInfo?.os_ver}</td>
                            <th>용도</th>
                            <td>{assetInfo?.service_nm}</td>
                        </tr>
                        <tr>
                            <th>담당자</th>
                            <td>{assetInfo?.manager_nm}</td>
                            <th>자산위치</th>
                            <td>{assetInfo?.location_nm}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div className="sub_title">
                    {'■ 자산중요도 등급'}
            </div>
            <div style={{padding: '0px 10px 20px 10px'}}>
                <div className="section">
                    <table className='search'>
                        <colgroup>
                            <col style={{width:'20%'}} />
                            <col style={{width:'20%'}} />
                            <col style={{width:'20%'}} />
                            <col style={{width:'20%'}} />
                            <col style={{width:'20%'}} />
                        </colgroup>
                        <tbody>
                        <tr>
                            <th>기밀성</th>
                            <th>무결성</th>
                            <th>가용성</th>
                            <th>자산 등급</th>
                            <th>자산 평가</th>
                        </tr>
                        <tr>
                            <td style={{textAlign:'center'}}>{assetInfo?.confidential_score}</td>
                            <td style={{textAlign:'center'}}>{assetInfo?.integrity_score}</td>
                            <td style={{textAlign:'center'}}>{assetInfo?.availability_score}</td>
                            <td style={{textAlign:'center'}}>{assetInfo?.asset_grd}</td>
                            <td style={{textAlign:'center'}}>{assetInfo?.asset_rnk}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    );
}
export default AssetInfo;